import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { authRequire } from "@dbox/core/api/cromie/auth";
import { ButtonPrimary, Input, TextLink } from "../atoms";
import { openSnackbar } from "@dbox/core/actions/common/ui";

function SigninForm() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onSubmit",
    defaultValues: {
      email: "",
      password: "",
    },
  });

  // Require step, for get the two-factor authentication code
  const onFormSubmit = async (values) => {
    const { email, password } = values;
    try {
      await authRequire(email, password);
      navigate(`/login/verification`, { state: { email } });
    } catch (err) {
      dispatch(
        openSnackbar({
          type: "error",
          message: t(
            `snackbar.message.error.${
              err?.response?.status || `404`
            }.data.message.${err?.response?.data?.message || `not_found`}`
          ),
        })
      );
    }
  };

  return (
    <form
      onSubmit={handleSubmit(onFormSubmit)}
      className="flex flex-col gap-y-4"
    >
      <Input
        name="email"
        type="email"
        label={t("input.label.email")}
        placeholder={t("input.placeholder.email")}
        formRegistration={register("email", {
          required: {
            value: true,
            message: t("input.field.required_field"),
          },
        })}
        errors={errors}
      />
      <Input
        isPassword
        name="password"
        label={t("input.label.password")}
        placeholder={t("input.placeholder.password")}
        formRegistration={register("password", {
          required: {
            value: true,
            message: t("input.field.required_field"),
          },
        })}
        errors={errors}
      />
      <div className="flex justify-end">
        <TextLink
          label={t("text_link.label.forgot_password")}
          iconPosition="right"
          onAction={() => navigate("/password/reset")}
        />
      </div>
      <ButtonPrimary
        type="submit"
        className="w-full"
        label={t("button.label.login")}
        data-cypress="login-btn"
      />
    </form>
  );
}

export default SigninForm;
